import { Icon } from '@components';
import { withFlexProps } from '@hocs';
import { Flex, theme, Typography } from '@styles';
import { ReactComponent as TapToSeeIcon } from '@svgs/tap-to-see.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TapToSeeButton = () => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center" gap={8} height="22px">
      <Icon height={18} opacity={0.4} SVG={TapToSeeIcon} width={18} />
      <Typography
        color={theme.colors.white[100]}
        opacity={0.4}
        variant="MS-regular-s14-lh22"
      >
        {t('Activities.TapToSee')}
      </Typography>
    </Flex>
  );
};

export default withFlexProps(TapToSeeButton);
